var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowBase)?_c('component-product-scripts-inner',{attrs:{"base":_vm.base}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }